import React from 'react'
import './AddressCard.css';
import Map from './Map';
import ClipLoader from "react-spinners/ClipLoader";


const AddressCard = (props) => {

    const override = {
        display: "flex",
        borderWidth: '5px',
        height: '50px',
        width: '50px',
        position:'absolute',
        left:'calc(50% - 25px)',
        bottom:'45px'
    
      };

  return (
    <div className='address_container'>
              <div className='address_img_container'>
              {/* <p className='collection_address'>Chatters Restuarant,<br></br> 58 John Street,<br></br>Dunoon,<br></br>PA23 8BJ</p> */}

                <p className='collection_address'>{props.line1},<br></br> {props.line2},<br></br>{props.line3},<br></br>{props.postcode}</p>
                <img
                  className='address_img'
                  alt='Property'
                  src={props.img}
                  loading="eager"
                />
              </div>
              <ClipLoader
                color={'#001e00'}
                loading={true}
                cssOverride={override}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              <Map width={'210px'} height={'130px'} radius={'3px'} src={props.mapLink}/>
    </div>
  )
}

export default AddressCard